import axios from "axios";
// import Swal from 'sweetalert2';

const baseURL = "https://apis.ajnavidya.com";

// const baseURL = "http://localhost:8080";

// const baseURL = "http://192.168.174.248:8080";

// const baseURL = "https://demo-api.ajnavidya.com";
// const baseURL =
//   (window.location.origin.includes("localhost") && "http://localhost:8080") ||
//   (window.location.origin.includes("demo") &&
//     "https://demo-api.ajnavidya.com") ||
//   (window.location.origin.includes("192.168.175.20") &&
//     "http://192.168.175.20:8080");

const API = axios.create({
  baseURL,
  headers: {
    token: localStorage.getItem("token"),
  },
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("user")) {
    req.headers.token = `${
      JSON.parse(localStorage.getItem("user")).refreshtoken
    }`;
  }
  return req;
});

export const login = (userData) => API.post(`${baseURL}/login`, userData);

export const forgotPassword = (email) =>
  API.post(`${baseURL}/forgotPassword`, email);

export const isLinkExpired = (token) =>
  API.get(`${baseURL}/isLinkExpired/${token}`);

export const resetPasswordApi = (email, token) =>
  API.patch(`${baseURL}/generate-password/${token}`, email);
export const getRecruiterCompany = () => API.get("/getRecruiterCompany");

export const getPosts = (companyId, status) =>
  API.get(
    `${baseURL}/getJobsByCompany?companyId=${companyId}&status=${status}`
  );

export const getAllActivePosts = (page = 1) =>
  API.get(`${baseURL}/getJobsByStatus?page=${page}`);

export const getCompanyById = (companyId) =>
  API.get(`/getCompany?companyId=${companyId}`);

export const getJobById = (postId, status = "") =>
  API.get(`/getJobById?postId=${postId}&${status}`);

export const getCreateHiringPostData = () =>
  API.get("/getCreateHiringPostData");

export const getAllApplicationsForJob = (postId) =>
  API.get(`/getAllApplicationsForJob?postId=${postId}`);

export const getAllInvitesForJobPost = (postId) =>
  API.get(`/getAllInvitesForJobPost?postId=${postId}`);

export const savePostInDraft = (postData) =>
  API.post("/savePostInDraft", { ...postData });

export const changeJobStatus = (status, postId) =>
  API.patch(`/changeJobStatus?status=${status}&postId=${postId}`);

export const createHiringPost = (postData) =>
  API.post("/createHiringPost", postData);

export const getUserById = (userId) => API.get(`/getUserById?userId=${userId}`);
export const userById = (userId) => API.get(`/userById?userId=${userId}`);

export const changeStatusOfInvite = (inviteId, status) =>
  API.patch(`/changeStatusOfInvite?inviteId=${inviteId}&status=${status}`);

export const acceptOrRejectApplication = (applicationId, status, postId) =>
  API.patch(
    `/acceptOrRejectApplication?status=${status}&applicationId=${applicationId}&postId=${postId}`
  );

export const getSingleStudentWork = (Id, studentId) =>
  API.get(`/getSingleStudentWork?id=${Id}&studentid=${studentId}`);

export const sendInvite = (studentId, postId) =>
  API.post(`/sendInvite?studentId=${studentId}&postId=${postId}`);

export const sendMessageForInvite = (studentId, postId, message) =>
  API.patch(`/sendMessageForInvite?studentId=${studentId}&postId=${postId}`, {
    message,
  });

export const uploadResume = (file) => API.post("/uploadResume", file);
export const uploadWork = (file) => API.post("/uploadWork", file);
export const uploadYoutubeLink = (url) => API.post("uploadYoutubeLink", url);

export const filterStudentsByBadges = (filter, page = 1) =>
  API.get(`/filterStudentsByBadges?filter=${filter}&page=${page}`);

export const filterJobs = (filter, page) =>
  API.get(
    `/filterJobs?jobRoleTitle=${filter.jobRoleTitle}&sector=${filter.sector}&location=${filter.location}&requiredLevel=${filter.requiredLevel}&packageOffered=${filter.packageOffered}&page=${page}`
  );

export const getAllApplicationsForUser = (page, query) =>
  API.get(`/getApplicationsByUser?page=${page}&${query}`);

export const getAllInvitesForStudent = () => API.get("/getAllInvites");

export const applyToJob = (postId) => API.post(`/applyToJob?postId=${postId}`);

export const saveOrRemoveSavedPost = (postId) =>
  API.post(`/saveOrRemoveSavedPost?postId=${postId}`);

export const getSavedPosts = () => API.get(`/getSavedPosts`);

export const signup = (formData) => API.post("/hiring/signup", formData);

export const createCompany = (data) => API.post("/createCompany", data);

export const signupRecruiter = (data) => API.post("/signupRecruiter", data);

export const getAllCompanies = () => API.get("/getAllCompanies");

export const addCompanyToUser = (companyId, email) =>
  API.patch(`/addCompanyToUser?companyId=${companyId}&email=${email}`);

export const changeNameEmail = (name, email, walletId) =>
  API.patch("/changeNameEmail", { name, email, walletId });

export const changePassword = (oldPassword, newPassword) =>
  API.patch("/changePassword", { oldPassword, newPassword });

export const changeStudentStatus = (status) =>
  API.patch(`/changeStudentStatus?status=${status}`);

export const updateCompanyDetails = (companyId, formData) =>
  API.patch(`/updateCompanyDetails?companyId=${companyId}`, formData);

export const changeProfilePhoto = (file) =>
  API.patch("/changeProfilePhoto", file);

export const getUpdatedPortfolio = (id) => {
  if (id) {
    return API.get(`/getUpdatedPortfolio?id=${id}`);
  }
  return API.get("/getUpdatedPortfolio");
};

export const updateWalletId = (walletId) => {
  API.post(`/updateWalletId`, { walletId });
};

export const locationByQuery = (text) => {
  return API.get(`/getLocationByQuery?location=${text}`);
};

export const editProfile = (data) => {
  return API.patch(`/editProfile`, data);
};

export const findTalent = (data, page) => {
  return API.get(`/findTalent${data}`, data);
};

export const addNewUser = (data) => {
  return API.post(`/send-message`, data);
};

export const getUsers = (userId) => {
  return API.get(`/getusers?userId=${userId}`);
};
export const getSingleUser = (userId) => {
  return API.get(`/getuser?userId=${userId}`);
};

export const deleteWork = (workId) => {
  return API.patch(`/deleteWork`, { id: workId });
};

export const getCompanyDetailsAndJobs = (recruiterid) => {
  return API.get(`/getJobPostByUserId?id=${recruiterid}`);
};

export const updateStudentWork = (data) => {
  return API.patch(`/editwork`, data);
};

export const getLocation = (query) => {
  return API.get(`/getLocationQuery?${query}`);
};

export const createTicket = (data) => {
  return API.post(`/create-ticket`, data);
};
